"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PickerGA = function PickerGA(_ref) {
  var action = _ref.action,
      category = _ref.category,
      label = _ref.label;
  return category && _reactGa.default.event({
    category: category,
    action: action,
    label: label
  });
};

var _default = PickerGA;
exports.default = _default;